/** Client-safe presentation metadata shared by formula-backed read models. */
export const REALIZATION_PROJECTED_MISS_VALUE_BASIS = 'approved_value_binding' as const;
// Executive wording only (#4631 headed-proof finding, 2026-08-17): 'binding'
// is forbidden client-facing vocabulary; the label names the same governed
// basis in reader language.
export const REALIZATION_PROJECTED_MISS_DOLLAR_BASIS_LABEL =
  'Approved value at risk';
